<template>
    <div class="block-editor comment-reply-as-private">
        <div class="editor-row customize-editor-minimize">
            <div class="editor-row-title">{{ $t("chatbotv2.blockEditorCommentId") }}</div>
            <TiptapEditor
                :placeholder="$t('chatbotv2.blockEditorCommentId')"
                :show-attributes="true"
                :max-character-count="500"
                v-model="clone.commentId"
            />
        </div>
        <div class="editor-row customize-editor-minimize">
            <div class="editor-row-title">{{ $t("chatbotv2.blockEditorMessage") }}</div>
            <TiptapEditor
                :placeholder="$t('chatbotv2.blockEditorMessagePh')"
                :show-attributes="true"
                :max-character-count="500"
                v-model="clone.message"
            />
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../../utils/log2";
import _ from "lodash";
import TiptapEditor from "../common/TiptapEditor";

const log = log2("InstagramCommentReplyAsPrivate");
export default {
    name: "InstagramCommentReplyAsPrivate",
    components: { TiptapEditor },
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep(this.value),
        };
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss">
.block-editor.comment-reply-as-private {
    padding: 20px;
    display: flex;
    gap: 20px;
    flex-direction: column;
    .editor-row {
        width: 100%;
        .editor-row-title {
            font-weight: bold;
            font-size: 16px;
        }
    }
}
</style>
